import { Button, makeStyles } from '@material-ui/core';
import React from 'react';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';

const useStyles = makeStyles((theme) => ({
	Btn: {
		textTransform: 'none',
	},
}));
// Component to open a model file in Express QA in new window.
const ExpressQABtn = ({ fileUrl, assetId }) => {
	const classes = useStyles();
	const expressQA = process.env.REACT_APP_EXPRESS_QA;
	const handleClick = () => {
		// open in a new tab.
		window.open(`${expressQA}/?assetIds=${assetId}`, '_blank');
	};
	return (
		<Button
			startIcon={<OpenInNewIcon />}
			color="primary"
			size="large"
			className={classes.Btn}
			onClick={handleClick}
		>
			Express QA
		</Button>
	);
};

export default ExpressQABtn;
